document.addEventListener("DOMContentLoaded", function(){
  const bodyElement = document.querySelector("body");
  
  const videoOpenBtn = document.querySelectorAll(".video-overlay-open");
  const videoOverlay = document.querySelector(".video-overlay");
  const videoCloseBtn = videoOverlay.querySelector(".video-overlay-close");
  let videoPlayer;

  videoOpenBtn.forEach(button => {
    button.addEventListener("click", function(e){
      e.preventDefault();
      
      const mp4 = button.dataset.video;
      
      videoPlayer = document.createElement("video");
      videoPlayer.setAttribute("controls", "true");
      videoPlayer.setAttribute("autoplay", "true");
      videoPlayer.setAttribute("loop", "true");
      videoPlayer.setAttribute("playsinline", "true");
      
      const source = document.createElement("source");
      source.setAttribute("src", mp4);
      source.setAttribute("type", "video/mp4");
      videoPlayer.appendChild(source);
      
      videoOverlay.appendChild(videoPlayer);
      videoOverlay.classList.add("active");

      bodyElement.classList.add("no-scroll");
      
      videoPlayer.play();
    });
  });

  videoCloseBtn.addEventListener("click", function(e){
    e.preventDefault();
    
    bodyElement.classList.remove("no-scroll");
    
    videoOverlay.classList.remove("active");
    videoPlayer.pause();
    videoPlayer.remove();
  });

  // CUSTOM SIZE
  const customSizeBtn = document.querySelectorAll(".set-custom-size");
  const customSizeInput = document.getElementById("input-custom-size");
  const customSizeForm = document.querySelector(".shopify-product-form");
  const customSizeFormExtraProductId = 50301127393622; // variant id

  if (customSizeInput && customSizeForm) {
    customSizeBtn.forEach(button => {
      button.addEventListener("click", function(e){
        e.preventDefault();
        customSizeBtn.forEach(button => {
          button.classList.remove("active");
        });
        button.classList.add("active");
        customSizeInput.value = button.dataset.value;
      });
    });
  }

  let productWithCustomSize = 0;
  let lineItemWithCustomSizeFound = -1;
  
  document.addEventListener("cart:change", function(){
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {        
        InitCustomSizeCheck(cart);

        if (lineItemWithCustomSizeFound > -1) {
          if (lineItemWithCustomSizeFound != productWithCustomSize) {
            fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({updates: {[customSizeFormExtraProductId]: productWithCustomSize}})
            }).then(() => { document.dispatchEvent(new Event("cart:refresh")); });
          }
        } else if (productWithCustomSize > 0) {
          fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: customSizeFormExtraProductId, quantity: productWithCustomSize})
          }).then(() => { document.dispatchEvent(new Event("cart:refresh")); });
        }
      });
  });

  const customSizeScrollTo = document.querySelectorAll('a[href="#SETUP-CUSTOM-SIZE"]');
  if (customSizeScrollTo) {
    customSizeScrollTo.forEach(button => {
      button.addEventListener("click", function(e){
        e.preventDefault();
        const header = document.querySelector('header');
        const customSizeFaq = document.querySelector('#section-product-custom-size');
        const customSizeFaqSection = customSizeFaq.closest(".shopify-section");
        const customSizeFaqButton = customSizeFaq.closest(".accordion__disclosure").querySelector(".accordion__toggle");
        
        if (customSizeFaq && header) {
          window.scroll({
            behavior: 'smooth',
            left: 0,
            top: customSizeFaqSection.offsetTop - header.offsetHeight
          });
          if (customSizeFaqButton) customSizeFaqButton.click();
        }
      });
    });
  }

  setTimeout(function(){
    const btSkeepersCustom = document.querySelector('.product-info__block-item .review__header');
    if (btSkeepersCustom) {
      btSkeepersCustom.addEventListener("click", function(e){
        e.preventDefault();
        const header = document.querySelector('header');
        const btSkeepersCustomGoto = document.querySelector('.shopify-section--skeepers');
        
        if (btSkeepersCustomGoto && header) {
          window.scroll({
            behavior: 'smooth',
            left: 0,
            top: btSkeepersCustomGoto.offsetTop - header.offsetHeight
          });
        }
      });
    }
  }, 1000);

  // Window load
  if (window.location.pathname == '/cart') {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        InitCustomSizeCheck(cart);
  
        if (lineItemWithCustomSizeFound > -1) {
          if (lineItemWithCustomSizeFound != productWithCustomSize) {
            fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({updates: {[customSizeFormExtraProductId]: productWithCustomSize}})
            }).then(() => { window.location.reload(); });
          }
        } else if (productWithCustomSize > 0) {
          fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: customSizeFormExtraProductId, quantity: productWithCustomSize})
          }).then(() => { window.location.reload(); });
        }
      });
  }

  function InitCustomSizeCheck(cart) {
    productWithCustomSize = 0;
    lineItemWithCustomSizeFound = -1;
    
    cart.items.forEach(item => {
      if (item.id != customSizeFormExtraProductId) {
        if (item.properties) {
          for (const property in item.properties) {
            if (property == 'Custom Size' && item.properties[property] != '') {
              productWithCustomSize += item.quantity;
            }
          }
        }
      } else {
        lineItemWithCustomSizeFound = item.quantity;
      }
    })
  }
  
});